
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/agent",
      function () {
        return require("private-next-pages/agent/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/agent"])
      });
    }
  